import { useQuery } from '@tanstack/react-query';
// import { subscriptionService } from '../../../services/subscription';

interface UseAllSubscriptionsParams {
  page: number;
  limit: number;
  search?: string;
  filter?: string;
  orderBy?: string;
  orderDirection?: 'asc' | 'desc';
}

interface SubscriptionsListResponse {
  subscriptions: any[];
  count: number;
  page: number;
  limit: number;
  totalPages: number;
}

// TODO: This hook needs to be updated to use the new organization_subscription system
// The backend getAllOrganizationSubscriptions query exists but needs proper integration
export const useAllSubscriptions = (params: UseAllSubscriptionsParams) => {
  return useQuery<SubscriptionsListResponse>({
    queryKey: ['subscriptions', 'all', params],
    queryFn: async (): Promise<SubscriptionsListResponse> => {
      // Temporary: Return empty data until admin functionality is properly implemented
      return {
        subscriptions: [],
        count: 0,
        page: params.page,
        limit: params.limit,
        totalPages: 0,
      };
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: false, // Disable this query until it's properly implemented
  });
};
